
<template>
  <div v-wechat-title="title">
    <NativeBar ref="menu" v-model="NativeBarId" />
    <div class="topRect" :style="'background: linear-gradient(left bottom,'+GetColorMain()+','+GetColorMainGradual()+');background: -webkit-linear-gradient(left bottom,'+GetColorMain()+','+GetColorMainGradual()+');'">
      <div class="info">
        <van-row>
          <van-col span="8">
            <van-image
              v-if="userData"
              round
              width="5em"
              height="5em"
              fit="cover"
              :src="userData.icon?userData.icon:'/img/defaultIcon.jpg'"
              @click="onChangeIcon"
            />
          </van-col>
          <van-col v-if="userData" span="14" class="userName">
            <span @click="onUserInfo">{{ userData.nickName }}</span><br>
            <span class="vipLevelRect" @click="onVip"><i :class="'iconfont '+data.vipLevelIcon" /> {{ (data&&data.vipLevelName)?data.vipLevelName:'' }}</span>
          </van-col>
          <van-col span="2"><i class="iconfont iconsetting" @click="onUserInfo" /></van-col>
        </van-row>
      </div>
    </div>

    <div class="storeRect">
      <div class="orderLine">
        <div class="orderRect" @click="onOrderList('ALL')">
          <i class="iconfont iconorder" /><br>
          <span>我的订单</span>
        </div>
        <div class="orderRect" @click="onOrderList('WAIT_PAY')">
          <i class="iconfont iconfukuan" /><br>
          <span>待付款</span>
          <div v-if="data && data.totalNeedPay>0" class="num" :style="'background-color: '+GetColorMain()">{{ data.totalNeedPay }}</div>
        </div>
        <div class="orderRect" @click="onOrderList('WAIT_GET')">
          <i class="iconfont icondaishouhuo1" /><br>
          <span>待收货</span>
          <div v-if="data && data.totalNeedReceiving>0" class="num" :style="'background-color: '+GetColorMain()">{{ data.totalNeedReceiving }}</div>
        </div>
        <div class="orderRect" @click="onOrderList('FINISH')">
          <i class="iconfont iconwancheng1" /><br>
          <span>已完成</span>
        </div>
        <!-- <div @click="onOrderService">
          <i class="iconfont iconshouhou" /><br>
          <span>售后</span>
        </div> -->
      </div>
      <div class="numList">
        <div @click="onFavorite">
          <span>{{ data?data.collectionNum:"0" }}</span><br>
          商品收藏
        </div>
        <div v-if="CheckSystemType('SSI')" @click="onVisitLog">
          <span>0</span><br>
          浏览记录
        </div>

        <div v-if="CheckSystemType('DiveBoss') && !checkIsInAlipay()" @click="onCertificate">
          <span>{{ data?data.cerificateNum:"0" }}</span><br>
          潜水证书
        </div>
        <div v-if="CheckSystemType('DiveBoss') && GetIsEnableInsurance() && !checkIsInAlipay()" @click="onInsurance">
          <span>{{ data?data.insuranceProgress:"0" }}</span><br>
          近期保单
        </div>
        <div v-if="CheckSystemType('DiveBoss')" @click="onMemberCard">
          <span>{{ data?data.memberCardNum:"0" }}</span><br>
          会员卡
        </div>
      </div>
    </div>
    <div v-if="data.isProUser" class="buttonRect">
      <div class="line" @click="onProUserInfo">
        <van-row>
          <van-col span="3"><i class="iconfont iconshouye" /></van-col>
          <van-col span="21">{{ GetSysTitle() }}{{ data.isCoach?"教练 ":"专业用户 " }}<span class="proUserName">{{ data.proName }}</span>
            <span class="welcome"> {{ getTimeState() }}</span>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="buttonRect">
      <div class="line" @click="onUserInfo">
        <van-row>
          <van-col span="3"><i class="iconfont iconsetting" /></van-col>
          <van-col span="21">我的信息</van-col>
        </van-row>
      </div>
      <template v-if="!checkIsInAlipay()">
        <div v-if="CheckSystemType('DiveBoss') && GetIsEnableInsurance()" class="line" @click="onGotoPage('/insurance/list')">
          <van-row>
            <van-col span="3"><i class="iconfont iconbaoxian" /></van-col>
            <van-col span="21">潜水保险</van-col>
          </van-row>
        </div>
        <div v-if="CheckSystemType('DiveBoss') && !GetIsEnableInsurance() && data.selfInsuranceUrl" class="line" @click="onVisit(data.selfInsuranceUrl)">
          <van-row>
            <van-col span="3"><i class="iconfont iconbaoxian" /></van-col>
            <van-col span="21">潜水保险</van-col>
          </van-row>
        </div>
      </template>

      <div class="line" @click="onAddress">
        <van-row>
          <van-col span="3"><i class="iconfont iconaddress" /></van-col>
          <van-col span="21">收件地址管理</van-col>
        </van-row>
      </div>
      <div class="line" @click="onCustomerList">
        <van-row>
          <van-col span="3"><i class="iconfont iconxueyuanxinxiguanli1" /></van-col>
          <van-col span="21">顾客信息管理</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')&&data.picCerificateNum>0" class="line" @click="onGotoPage('/pic/picListUser')">
        <van-row>
          <van-col span="3"><i class="iconfont iconpropic" /></van-col>
          <van-col span="21">我的待发放证书({{ data.picCerificateNum }})</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onHeadIcon">
        <van-row>
          <van-col span="3"><i class="iconfont iconguest" /></van-col>
          <van-col span="21">更新证书照片</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onChangeUserQrCode">
        <van-row>
          <van-col span="3"><i class="iconfont iconguest" /></van-col>
          <van-col span="21">更新我的二维码</van-col>
        </van-row>
      </div>

      <div v-if="CheckSystemType('DiveBoss')&& data.aidaAccountNum>0" class="line" @click="onGotoPage('/my/aidaAccount')">
        <van-row>
          <van-col span="3"><i class="iconfont iconrectAIDA" /></van-col>
          <van-col span="21">
            AIDA账号管理({{ data.aidaAccountNum }})
          </van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')&& data.examNum>0" class="line" @click="onGotoPage('/divetrip/myExam')">
        <van-row>
          <van-col span="3"><i class="iconfont iconkaoshi" /></van-col>
          <van-col span="21">我的测验({{ data.examNum }})</van-col>
        </van-row>
      </div>
      <div v-for="(item,index) in data.staticPageList" :key="index" class="line" @click="onStaticPage(item.key)">
        <van-row>
          <van-col span="3"><i class="iconfont iconguanyu" /></van-col>
          <van-col span="21">{{ item.title }}</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onGotoPage('/my/relationShipNetWork')">
        <van-row>
          <van-col span="3"><i class="iconfont iconguest" /></van-col>
          <van-col span="21">推荐人关系网络</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onGotoPage('/my/paper')">
        <van-row>
          <van-col span="3"><i class="iconfont iconguest" /></van-col>
          <van-col span="21">我的推荐海报</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss') && data && data.isMermaidAgent" class="line" @click="onGotoPage('/mermaid/agentList')">
        <van-row>
          <van-col span="3"><i class="iconfont iconguest" /></van-col>
          <van-col span="21">《寻找美人鱼计划》管理</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss') && data && data.isFindMermaid!==null" class="line" @click="onGotoPage('/mermaid/mermaidUser')">
        <van-row>
          <van-col span="3"><i class="iconfont iconguest" /></van-col>
          <van-col span="21">《寻找美人鱼计划》报名</van-col>
        </van-row>
      </div>

      <div v-if="CheckSystemType('SSI')" class="line" @click="onHelp">
        <van-row>
          <van-col span="3"><i class="iconfont iconbangzhu" /></van-col>
          <van-col span="21">帮助中心</van-col>
        </van-row>
      </div>
      <div class="line" @click="onComplaint">
        <van-row>
          <van-col span="3"><i class="iconfont iconbi" /></van-col>
          <van-col span="21">投诉建议</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('SSI')" class="line" @click="onAboutMe">
        <van-row>
          <van-col span="3"><i class="iconfont iconguanyu" /></van-col>
          <van-col span="21">关于我们</van-col>
        </van-row>
      </div>
      <div v-if="!checkIsInAlipay()" class="line" @click="onReLogin">
        <van-row>
          <van-col span="3"><i class="iconfont iconrotate" /></van-col>
          <van-col span="21">刷新登录</van-col>
        </van-row>
      </div>
      <div v-if="false" class="line">
        <van-row>
          <van-col span="3"><i class="iconfont icontuichudenglu" /></van-col>
          <van-col span="21">退出登陆</van-col>
        </van-row>
      </div>
    </div>
    <div class="emptyRect" />
  </div>
</template>
<script>
import request from '@/utils/request'
import NativeBar from '@/components/NativeBar'
import { Button, Image, Dialog } from 'vant'
import { checkIsInAlipay, MyNotify, getUserBase } from '@/utils/base'
import { CheckSystemType } from '@/utils/request'
import { GetIsEnableInsurance, getTimeState, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine, GetColorMainGradual } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    NativeBar
  },
  data() {
    return {
      NativeBarId: '',
      title: '个人中心',
      data: {
        vipLevelName: '',
        isCoach: false,
        picCerificateNum: 0,
        staticPageList: [],
        selfInsuranceUrl: undefined
      },
      userData: {
        icon: undefined
      }
    }
  },
  activated() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'my'
    }, 0)
    this.$refs.menu.resetNum()
  },
  created() {
    getUserBase(data => {
      console.log('用户数据', data)
      this.userData = data
    })
    this.onInit()
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'my'
    }, 0)
  },
  methods: {
    checkIsInAlipay,
    GetIsEnableInsurance,
    getTimeState,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetColorMainGradual,
    CheckSystemType,
    onInit() {
      request({
        url: '/user/getMyPageInfo',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
      })
    },
    onAddress() {
      this.$router.push('/store/addressList?isManage=true')
    },
    onComplaint() {
      this.$router.push('/my/complaint')
    },
    onFavorite() {
      this.$router.push('/store/favorite')
    },
    onOrderList(type) {
      this.$router.push('/store/orderList?type=' + type)
    },
    onOrderService() {
      MyNotify('info', '暂未开放')
    },
    onVisitLog() {
      MyNotify('info', '暂未开放')
    },
    onChangeIcon() {
      this.$router.push('/my/changeIcon')
    },
    onCertificate() {
      this.$router.push('/my/myCerificate')
    },
    onInsurance() {
      this.$router.push('/insurance/myList')
    },
    onMemberCard() {
      this.$router.push('/memberCard/memberCardList')
    },
    onCustomerList() {
      this.$router.push('/my/customerList')
    },
    onHelp() {
      this.$router.push('/my/help')
    },
    onAboutMe() {
      MyNotify('info', '暂未开放')
    },
    onHeadIcon() {
      this.$router.push('/my/changeHeadIcon')
    },
    onChangeUserQrCode() {
      this.$router.push('/my/changeUserQrCode')
    },
    onUserInfo() {
      this.$router.push('/my/updafeInfo')
    },
    onReLogin() {
      this.$store.dispatch('user/reLogin')
      MyNotify('info', '重新登录成功')
      this.onInit()
    },
    onVip() {
      this.$router.push('/my/vip')
    },
    onProUserInfo() {
      MyNotify('info', '教练相关功能暂未开放')
    },
    onGotoPage(url) {
      if (!url || url === '') {
        MyNotify('info', '暂未开放')
        return
      }
      this.$router.push(url)
    }, onStaticPage(key) {
      this.$router.push('/home/staticPage/' + key)
    },
    onVisit(url) {
      window.location.href = url
    }
  }
}
</script>
<style scoped>
.topRect{

  color: #fff;
  padding: 2em 1.5em;
}
.topRect .userName{
  font-size: 1.1em;
  padding: 1em 0;
}
.storeRect {
  background-color: #fff;
  margin: 1em;
  padding: 1em;
  border-radius: 0.5em;
}
.storeRect .orderLine{
  border-bottom: 1px solid #f1f1f1;
  display:flex;
  padding-bottom: 0.8em;
}
.storeRect .orderLine .orderRect{
  position: relative;
  text-align: center;
  flex:1;
  line-height: 1.5em;
}
.storeRect .orderLine span{
  font-size: 0.9em;
}
.storeRect .orderLine .orderRect .num{
  position:absolute;
  right: 2em;
  top: 0em;
  color: #fff;
  font-size: 0.7em;
  border-radius: 1em;
  text-align: center;
  width: 1.4em;
  height: 1.4em;
  line-height: 1.4em;
}
.storeRect .numList{
  display:flex;
  padding-top: 0.8em;
}
.storeRect .numList div{
  text-align: center;
  flex:1;
  font-size: 0.9em;
  line-height: 1.5em;
}
.storeRect .numList span{
  font-size: 1.5em;
  font-weight: 700;
}

.buttonRect{
  background-color: #fff;
  margin: 1em;
  padding: 0.2em 1em;
  border-radius: 0.5em;
}

.buttonRect .line{
  line-height: 2.5em;
  border-bottom: 1px solid #f1f1f1;
}
.buttonRect .line:last-child
{
   border-bottom:none;
}
.vipLevelRect{
  font-size: 0.85em;
  line-height: 2em;
}
.welcome{
  font-size: 0.7em;
  color: #999;
}
.proUserName{
  font-weight: 700;
}
.emptyRect{
  height: 3em;
}
</style>
